module.exports = __webpack_public_path__ + "img/1H.d910c223.png";